import React, { useState, useEffect, useContext } from 'react'
import {
    Row,
    Col,
    Form,
    FormGroup,
    Input,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    Button,
    Label
} from 'reactstrap'

import TagsInput from 'react-tagsinput'
import { Editor } from 'react-draft-wysiwyg'
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js'
import { draftToMarkdown, markdownToDraft } from 'markdown-draft-js'

import toastr from 'toastr'
import { Link } from 'react-router-dom'

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import 'react-tagsinput/react-tagsinput.css'
import 'toastr/build/toastr.min.css'

import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'
import { findLastIndex } from 'lodash'

const FormPage = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const units = [{
        value: 'g',
        label: 'g'
    }, {
        value: 'kg',
        label: 'kg'
    }, {
        value: 'l',
        label: 'l'
    }, {
        value: 'ml',
        label: 'ml'
    }, {
        value: 'oz',
        label: 'oz'
    }, {
        value: 'lb',
        label: 'lb'
    }]

    const [id, setId] = useState('')
    const [name, setName] = useState('')
    const [catalogId, setCatalogId] = useState('')
    const [familyId, setFamilyId] = useState('')
    const [categoryId, setCategoryId] = useState('')
    const [subcategoryId, setSubCategoryId] = useState('')
    const [brandId, setBrandId] = useState('')
    const [supplierId, setSupplierId] = useState('')
    const [sku, setSKU] = useState('')
    const [upc, setUPC] = useState('')
    const [supplierCode, setSupplierCode] = useState('')
    const [productCode, setProductCode] = useState('')
    const [description, setDescription] = useState('')
    const [tags, setTags] = useState([])
    const [featured, setFeatured] = useState(false)
    const [weight, setWeight] = useState('')
    const [weightUnit, setWeightUnit] = useState('g')
    const [manageStock, setManageStock] = useState(true)
    const [sellable, setSellable] = useState(true)
    const [isActive, setIsActive] = useState(true)
    const [buyPrice, setBuyPrice] = useState()
    const [wholeSalePrice, setWholeSalePrice] = useState()
    const [retailPrice, setRetailPrice] = useState()
    const [hasVariants, setHasVariants] = useState(false)
    const [variants, setVariants] = useState([])
    const [editorState, setEditorState] = useState(EditorState.createEmpty())
    const [model, setModel] = useState('')
    const [gender, setGender] = useState('')
    const [initialStock, setInitialStock] = useState(0)
    const [product, setProduct] = useState(props.product)
    const [tempVariant, setTempVariant] = useState({
        name: false,
        vendoraCode: false,
        sku: false,
        buyPrice: false,
        wholeSalePrice: false,
        retailPrice: false,
        firstOption: {
            label: false,
            value: false
        },
        secondOption: {
            label: false,
            value: false
        },
        thirdOption: {
            label: false,
            value: false
        }
    })

    // Relations
    const [catalogs, setCatalogs] = useState([])
    const [families, setFamilies] = useState([])
    const [categories, setCategories] = useState([])
    const [subcategories, setSubCategories] = useState([])
    const [brands, setBrands] = useState([])
    const [suppliers, setSuppliers] = useState([])
    // const [allProductCodes, setAllProductCodes] = useState([])

    useEffect(() => {
        (async () => {
            await fetchCatalogs()
            await fetchFamilies()
            await fetchBrands()
            await fetchSuppliers()
            // await fetchAllProductCodes()
        })()

        // async function fetchAllProductCodes() {
        //     const response = await ApiService.getProductCodes()
        //     let data = []
        //     response.data.codes.map(c => {
        //         return data.push({ code: c.productCode })
        //     })

        //     setAllProductCodes(data)
        // }

        async function fetchCatalogs() {
            setLoading(true)
            const response = await ApiService.getCatalogs()
            let catalogs = []

            response.data.catalogs.map((catalog) => {
                const item = {
                    value: catalog.id,
                    label: catalog.name,
                }
    
                return catalogs.push(item)
            })
            setLoading(false)
            setCatalogs(catalogs)
        }

        async function fetchFamilies() {
            setLoading(true)
            const response = await ApiService.getFamily()
            let data = []

            response.data.data.map((item) => {
                return data.push({
                    value: item.id,
                    label: item.name,
                })
            })
            setLoading(false)
            setFamilies(data)
        }

        async function fetchBrands() {
            setLoading(true)
            const response = await ApiService.getBrands()
            let brands = []

            response.data.data.map((brand) => {
                const item = {
                    value: brand.id,
                    label: brand.name,
                }
    
                return brands.push(item)
            })
            setLoading(findLastIndex)
            setBrands(brands)
        }

        async function fetchSuppliers() {
            setLoading(true)
            const response = await ApiService.getSuppliers()
            let suppliers = []

            response.data.suppliers.map((supplier) => {    
                return suppliers.push({
                    value: supplier.id,
                    label: supplier.nombreComercial,
                })
            })
            setLoading(false)
            setSuppliers(suppliers)
        }
    }, []) // eslint-disable-line

    async function fetchCategories(id) {
        setLoading(true)
        const response = await ApiService.getCategoriesByFamilyId(id)
        let data = []

        response.data.data.map((item) => {
            return data.push({
                value: item.id,
                label: item.name,
            })
        })
        setLoading(false)
        setCategories(data)
    }

    async function fetchSubcategories(id) {
        setLoading(true)
        const response = await ApiService.getSubcategoriesByCategoryId(id)
        let data = []

        response.data.data.map((item) => {
            return data.push({
                value: item.id,
                label: item.name,
            })
        })
        setLoading(false)
        setSubCategories(data)
    }

    useEffect(() => {
        if (props.product !== undefined) { 
            const { product } = props
            const tags = product.tags || []
            const description = markdownToDraft(product.description)

            setId(product.id)
            setName(product.name)
            setCatalogId(product.catalogId)
            setSupplierId(product.supplierId)
            setFamilyId(product.familyId)
            setCategoryId(product.categoryId)
            setSubCategoryId(product.subcategoryId)
            setBrandId(product.brandId)
            setTags(tags)
            setGender(product.gender)
            setModel(product.model)
            setInitialStock(product.initialStock)
            setProductCode(product.productCode)
            setSupplierCode(product.supplierCode)
            setDescription(product.description)
            setSKU(product.sku)
            setUPC(product.upc)
            setWeight(product.weight)
            setWeightUnit(product.weightUnit)
            setBuyPrice(product.buyPrice)
            setWholeSalePrice(product.wholeSalePrice)
            setRetailPrice(product.retailPrice)
            setHasVariants(product.itHasVariants)
            setVariants(product.variants)
            setSellable(product.sellable)
            setIsActive(product.isActive)
            setManageStock(product.manageStock)
            setFeatured(product.featured)

            if (product.familyId !== undefined) { 
                fetchCategories(product.familyId)
            }

            if (product.categoryId !== undefined) { 
                fetchSubcategories(product.categoryId)
            }

            setEditorState(EditorState.createWithContent(convertFromRaw(description)))
            setProduct(product)
        }
    }, [props, product]) // eslint-disable-line

    const onEditorStateChange = (editorState) => {
        const description = draftToMarkdown(convertToRaw(editorState.getCurrentContent()))

        setEditorState(editorState)
        setDescription(description)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        
        if (!_validateForm()) {
            toastr.error('No olvides llenar los campos.', 'Error')

            return
        }

        const data = {
            name,
            catalogId,
            supplierId,
            familyId,
            categoryId,
            subcategoryId,
            brandId,
            tags,
            productCode,
            supplierCode,
            upc,
            description,
            sku,
            weight,
            weightUnit,
            buyPrice,
            wholeSalePrice,
            retailPrice,
            hasVariants,
            variants,
            sellable,
            isActive,
            manageStock,
            featured,
            initialStock,
            model,
            gender
        }
        setLoading(true)
        if (props.product !== undefined) { 
            const response = await ApiService.updateProduct({...data, id}).catch(error => {
                toastr.error('No pude editar este producto', 'Error')
            })

            if (response.data.success) {
                toastr.success('Edité un producto', '¡Éxito!')
            }
            setLoading(false)
            return
        }

        const response = await ApiService.createProduct(data).catch(error => {
            toastr.error('No pude agregar este producto', 'Error')
        })

        if (response.data.success) {
            toastr.success(`${name} fue agregado`, '¡Éxito!')
        }
        setLoading(false)
        _clearForm()
    }

    const _handleFamilyChange = async (e) => {
        const id = e.target.value

        setFamilyId(id)
        await fetchCategories(id)
    }

    const _handleCategoryChange = async (e) => {
        const id = e.target.value

        setCategoryId(id)
        await fetchSubcategories(id)
    }

    const _validateForm = () => {
        if (name === '') { return false }
        if (productCode === '') { return false }
        if (catalogId === '') { return false }
        if (familyId === '') { return false }
        if (categoryId === '') { return false }
        if (subcategoryId === '') { return false }
        if (brandId === '') { return false }
        if (supplierId === '') { return false }
        if (supplierCode === '') { return false }
        if (hasVariants && variants.length < 1) { return false }

        return true
    }

    const _clearForm = () => {
        document.getElementById('product-create').reset()
        document.getElementById('name').focus()

        setName('')
        setTags([])
        setFamilyId('')
        setCategoryId('')
        setSubCategoryId('')
        setBrandId('')
        setVariants([])
        setHasVariants(false)
        setEditorState(EditorState.createEmpty())

        document.getElementById('supplier').selectedIndex = 0
        document.getElementById('catalog').selectedIndex = 0
        document.getElementById('brand').selectedIndex = 0
        document.getElementById('family').selectedIndex = 0
        document.getElementById('category').selectedIndex = 0
        document.getElementById('subcategory').selectedIndex = 0
    }

    const generateVendoraCode = async (e) => {
        // var matches = name.match(/\b(\w)/g) // ['J','S','O','N']
        // var acronym = matches.join('').toUpperCase() // JSON

        let prefix = (Math.random() + 1).toString(36).substr(2,6).toUpperCase()
        const name = e.target.value

        setName(name)
        setProductCode(prefix)
    }

    const _deleteVariant = async (name) => {
        let data = await variants.filter((item) => {
            return item.name !== name
        })

        setVariants(data)
    }

    const _addProductVariant = async (e) => {
        e.preventDefault()
        let variant = tempVariant

        if (
            variant.buyPrice === false || 
            variant.wholeSalePrice === false || 
            variant.retailPrice === false ||
            variant.firstOption.value === false
        ) {
            toastr.error('No puedes agregar una variación vacía', 'Error')

            return
        }

        const initials = variant.firstOption.value.split(' ').map((n) => n[0]).join('').toUpperCase()
        const delta = variant.secondOption.value ? variant.secondOption.value.split('.').join('').toUpperCase() : ''
        variant.name = `${variant.firstOption.value} / ${variant.secondOption.value}`
        variant.vendoraCode = `${productCode}-${initials}` // @todo: is it unique?
        variant.sku = `${productCode}-${initials}-${delta}` // @todo: is it unique?

        let data = variants
        data.push(variant)
        setVariants(data)
        setTempVariant({
            ...tempVariant,
            name: false,
            sku: false,
            vendoraCode: false
        })

        toastr.success(`${variant.name} agregado`, 'Éxito')
    }

    return(
        <React.Fragment>
            <Form id="product-create" method="POST" onSubmit={ handleSubmit }>
                <Row>
                    <Col sm="12" xs="12">
                        <Card style={{textAlign: 'right'}}>
                            <CardBody>
                                <Link 
                                    className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2"
                                    to="/productos"
                                >
                                    Cancelar
                                </Link>

                                <Button
                                    type="submit"
                                    color="primary"
                                    className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    <i className={`mdi mdi-check`}></i> Guardar
                                </Button>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardBody>
                                <CardTitle>
                                    información General
                                </CardTitle>
                                <CardSubtitle className="mb-3">
                                    Ingresa el nombre del producto,
                                    las categorías a las que
                                    pertenece. Es muy útil que
                                    agregues todos los datos, para
                                    mantener mejor organizado tu
                                    inventario.
                                </CardSubtitle>

                                <Row>
                                    <Col sm="6">
                                        <Row>
                                            <Col sm="12">
                                                <FormGroup>
                                                    <Label htmlFor="name">
                                                        Nombre del Producto *
                                                    </Label>
                                                    <Input
                                                        id="name"
                                                        name="productName"
                                                        type="text"
                                                        placeholder="Women's platform sandal with Double G"
                                                        className="form-control"
                                                        value={name}
                                                        required
                                                        onChange={(event) => { generateVendoraCode(event) }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm="4">
                                                <FormGroup>
                                                    <Label htmlFor="productCode">
                                                        Modelo *
                                                    </Label>
                                                    <Input
                                                        id="model"
                                                        name="model"
                                                        type="text"
                                                        className="form-control"
                                                        value={model}
                                                        required
                                                        onChange={(event) => setModel(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm="4">
                                                <FormGroup>
                                                    <Label htmlFor="productCode">
                                                        Código Vendora *
                                                    </Label>
                                                    <Input
                                                        id="productCode"
                                                        name="productCode"
                                                        type="text"
                                                        className="form-control"
                                                        value={productCode}
                                                        required
                                                        readOnly
                                                        onChange={(event) => setProductCode(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm="4">
                                                <FormGroup>
                                                    <Label htmlFor="supplierCode">
                                                        Código Proveedor *
                                                    </Label>
                                                    <Input
                                                        id="supplierCode"
                                                        name="supplierCode"
                                                        type="text"
                                                        className="form-control"
                                                        value={supplierCode}
                                                        required
                                                        onChange={(event) => setSupplierCode(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm="6">
                                                <FormGroup>
                                                    <Label htmlFor="sku">
                                                        SKU
                                                    </Label>
                                                    <Input
                                                        id="sku"
                                                        name="sku"
                                                        type="text"
                                                        className="form-control"
                                                        value={sku}
                                                        onChange={(event) => setSKU(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm="6">
                                                <FormGroup>
                                                    <Label htmlFor="upc">
                                                        UPC
                                                    </Label>
                                                    <Input
                                                        id="upc"
                                                        name="upc"
                                                        type="text"
                                                        className="form-control"
                                                        value={upc}
                                                        onChange={(event) => setUPC(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label htmlFor="upc">
                                                        Gender
                                                    </Label>

                                                    <select id="gender" defaultValue={gender}
                                                        className="custom-select"
                                                        onChange={(event) => setGender(event.target.value)}>
                                                            <option value={'Neutro'}>Neutro</option>
                                                            <option value={'Femenino'}>Femenino</option>
                                                            <option value={'Masculino'}>Masculino</option>
                                                    </select>
                                                </FormGroup>
                                            </Col>

                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label htmlFor="upc">
                                                        Stock Inicial
                                                    </Label>
                                                    <Input
                                                        type="number"
                                                        className="form-control"
                                                        value={initialStock}
                                                        onChange={(event) => setInitialStock(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm="4">
                                                <FormGroup>
                                                    <Label className="control-label">
                                                        Catálogo *
                                                    </Label>
                                                    <select className="custom-select"
                                                        defaultValue={supplierId}
                                                        id="catalog"
                                                        name="catalog"
                                                        onChange={(event) => setCatalogId(event.target.value)}>
                                                        <option key="0" value="0">Seleccione un catálogo... </option> 
                                                        {catalogs.map((item, i) => {
                                                            let selected = catalogId === item.value ? 'selected' : ''
                                                            return (
                                                                <option key={i} value={item.value} selected={selected}>{item.label}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </FormGroup>
                                            </Col>

                                            <Col sm="4">
                                                <FormGroup>
                                                    <Label className="control-label">
                                                        Proveedor *
                                                    </Label>
                                                    <select className="custom-select"
                                                        defaultValue={supplierId}
                                                        id="supplier"
                                                        name="supplier"
                                                        onChange={(event) => setSupplierId(event.target.value)}>
                                                        <option key="0" value="0">Seleccione un proveedor... </option> 
                                                        {suppliers.map((item, i) => {
                                                            let selected = supplierId === item.value ? 'selected' : ''
                                                            return (
                                                                <option key={i} value={item.value} selected={selected}>{item.label}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </FormGroup>
                                            </Col>

                                            <Col sm="4">
                                                <FormGroup>
                                                    <Label className="control-label">
                                                        Marca *
                                                    </Label>
                                                    <select className="custom-select"
                                                        defaultValue={brandId}
                                                        id="brand"
                                                        name="brand"
                                                        onChange={(event) => setBrandId(event.target.value)}>
                                                        <option key="0" value="0">Seleccione una marca... </option> 
                                                        {brands.map((item, i) => {
                                                            let selected = brandId === item.value ? 'selected' : ''
                                                            return (
                                                                <option key={i} value={item.value} selected={selected}>{item.label}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm="4">
                                                <FormGroup>
                                                    <Label className="control-label">
                                                        Familia *
                                                    </Label>
                                                    <select className="custom-select"
                                                        defaultValue={familyId}
                                                        id="family"
                                                        name="family"
                                                        onChange={ _handleFamilyChange }>
                                                        <option key="0" value="0">Seleccione una familia... </option> 
                                                        {families.map((item, i) => {
                                                            let selected = familyId === item.value ? 'selected' : ''
                                                            return (
                                                                <option key={i} value={item.value} selected={selected}>{item.label}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </FormGroup>
                                            </Col>

                                            <Col sm="4">
                                                <FormGroup>
                                                    <Label className="control-label">
                                                        Categoría *
                                                    </Label>
                                                    <select className="custom-select"
                                                        defaultValue={categoryId}
                                                        id="category"
                                                        name="category"
                                                        onChange={ _handleCategoryChange }>
                                                        <option key="0" value="0">Seleccione una categoría... </option> 
                                                        {categories.map((item, i) => {
                                                            let selected = categoryId === item.value ? 'selected' : ''
                                                            return (
                                                                <option key={i} value={item.value} selected={selected}>{item.label}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </FormGroup>
                                            </Col>

                                            <Col sm="4">
                                                <FormGroup>
                                                    <Label className="control-label">
                                                        Subcategoría *
                                                    </Label>
                                                    <select className="custom-select"
                                                        defaultValue={categoryId}
                                                        id="subcategory"
                                                        name="subcategory"
                                                        onChange={(e) => { setSubCategoryId(e.target.value) }}>
                                                        <option key="0" value="0">Seleccione una subcategoría... </option> 
                                                        {subcategories.map((item, i) => {
                                                            let selected = subcategoryId === item.value ? 'selected' : ''
                                                            return (
                                                                <option key={i} value={item.value} selected={selected}>{item.label}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={6}>
                                                <Row>
                                                    <Col sm={9}>
                                                        <FormGroup>
                                                            <Label htmlFor="weight">
                                                                Peso
                                                            </Label>
                                                            <Input
                                                                id="weight"
                                                                name="weight"
                                                                type="text"
                                                                className="form-control"
                                                                value={weight}
                                                                onChange={(event) => setWeight(event.target.value)}
                                                            />
                                                        </FormGroup>
                                                    </Col>

                                                    <Col sm={3}>
                                                        <Label htmlFor="weight">
                                                            Unidad
                                                        </Label>
                                                        <FormGroup>
                                                            <select className="custom-select"
                                                                defaultValue={weightUnit}
                                                                onChange={(event) => setWeightUnit(event.target.value)}>
                                                                {units.map((u, i) => {
                                                                    let selected = weightUnit === u.value ? 'selected' : ''
                                                                    return (
                                                                        <option key={i} value={u.value} selected={selected}>{u.label}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label className="control-label">
                                                        Etiquetas
                                                    </Label>
                                                    <TagsInput
                                                        value={tags}
                                                        onChange={(value) => setTags(value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={4}>
                                                <FormGroup>
                                                    <Label htmlFor="buyPrice">
                                                        Precio Compra
                                                    </Label>
                                                    <Input
                                                        id="buyPrice"
                                                        name="buyPrice"
                                                        type="text"
                                                        className="form-control"
                                                        value={buyPrice}
                                                        onChange={(event) => setBuyPrice(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm={4}>
                                                <FormGroup>
                                                    <Label htmlFor="wholeSalePrice">
                                                        Precio Vendora
                                                    </Label>
                                                    <Input
                                                        id="wholeSalePrice"
                                                        name="wholeSalePrice"
                                                        type="text"
                                                        className="form-control"
                                                        value={wholeSalePrice}
                                                        onChange={(event) => setWholeSalePrice(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm={4}>
                                                <FormGroup>
                                                    <Label htmlFor="retailPrice">
                                                        Precio Venta Sugerido
                                                    </Label>
                                                    <Input
                                                        id="retailPrice"
                                                        name="retailPrice"
                                                        type="text"
                                                        className="form-control"
                                                        value={retailPrice}
                                                        onChange={(event) => setRetailPrice(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col sm="6">
                                        <FormGroup>
                                            <Label htmlFor="description">
                                                Descripción del
                                                Producto
                                            </Label>
                                            <Editor
                                                editorState={editorState}
                                                onEditorStateChange={onEditorStateChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardBody>
                                <CardTitle>
                                    Variaciones de Producto <small> Se creará automáticamente una variación única, a menos que actives múltiples variaciones.</small>
                                </CardTitle>
                                <CardSubtitle className="mb-3">
                                    <p>
                                        Un producto puede tener una o mas variaciones, ej. diferentes tallas y/o colores. Cada variación tiene sus propios precios, niveles de stock, entre otras cosas.
                                    </p>

                                    <div className="custom-control custom-checkbox mb-3">
                                        <input type="checkbox" className="custom-control-input" id="CustomCheck1" onChange={() => false} checked={hasVariants} />
                                        <label className="custom-control-label" onClick={() => { setHasVariants(!hasVariants) }} >Este producto tiene múltiples variaciones.</label>
                                    </div>
                                </CardSubtitle>
                                {hasVariants && (
                                    <React.Fragment>
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>Opción 1:</Label>
                                                    <select 
                                                        className="custom-select"
                                                        defaultValue={variants[0] ? variants[0].firstOption.label : false}
                                                        onChange={(event) => {
                                                            setTempVariant({
                                                                ...tempVariant,
                                                                firstOption: {
                                                                    ...tempVariant.firstOption,
                                                                    label: event.target.value
                                                                }
                                                            })
                                                        }}
                                                    >
                                                        <option value={false}>Seleccione una opción</option>
                                                        <option value="Color">Color</option>
                                                        <option value="Talla">Talla</option>
                                                        <option value="Tamaño">Tamaño</option>
                                                        <option value="Piezas">Piezas</option>
                                                        <option value="Presentación">Presentación</option>
                                                    </select>
                                                </FormGroup>
                                            </Col>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>Valor</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(event) => {
                                                            setTempVariant({
                                                                ...tempVariant,
                                                                firstOption: {
                                                                    ...tempVariant.firstOption,
                                                                    value: event.target.value
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>Opción 2:</Label>
                                                    <select 
                                                        className="custom-select"
                                                        defaultValue={variants[0] ? variants[0].secondOption.label : false}
                                                        onChange={(event) => {
                                                            setTempVariant({
                                                                ...tempVariant,
                                                                secondOption: {
                                                                    ...tempVariant.secondOption,
                                                                    label: event.target.value
                                                                }
                                                            })
                                                        }}
                                                    >
                                                        <option value={false}>Seleccione una opción</option>
                                                        <option value="Color">Color</option>
                                                        <option value="Talla">Talla</option>
                                                        <option value="Tamaño">Tamaño</option>
                                                        <option value="Piezas">Piezas</option>
                                                        <option value="Presentación">Presentación</option>
                                                    </select>
                                                </FormGroup>
                                            </Col>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>Valor</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(event) => {
                                                            setTempVariant({
                                                                ...tempVariant,
                                                                secondOption: {
                                                                    ...tempVariant.secondOption,
                                                                    value: event.target.value
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>Opción 3:</Label>
                                                    <select 
                                                        className="custom-select"
                                                        defaultValue={variants[0] ? variants[0].thirdOption.label : false}
                                                        onChange={(event) => {
                                                            setTempVariant({
                                                                ...tempVariant,
                                                                thirdOption: {
                                                                    ...tempVariant.thirdOption,
                                                                    label: event.target.value
                                                                }
                                                            })
                                                        }}
                                                    >
                                                        <option value={false}>Seleccione una opción</option>
                                                        <option value="Color">Color</option>
                                                        <option value="Talla">Talla</option>
                                                        <option value="Tamaño">Tamaño</option>
                                                        <option value="Piezas">Piezas</option>
                                                        <option value="Presentación">Presentación</option>
                                                    </select>
                                                </FormGroup>
                                            </Col>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>Valor</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(event) => {
                                                            setTempVariant({
                                                                ...tempVariant,
                                                                thirdOption: {
                                                                    ...tempVariant.thirdOption,
                                                                    value: event.target.value
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="3">
                                                <FormGroup>
                                                    <Input
                                                        type="number"
                                                        placeholder="Precio Compra"
                                                        className="form-control"
                                                        onChange={(event) => {
                                                            setTempVariant({
                                                                ...tempVariant,
                                                                buyPrice: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm="3">
                                                <FormGroup>
                                                    <Input
                                                        type="number"
                                                        placeholder="Precio Vendora"
                                                        className="form-control"
                                                        onChange={(event) => {
                                                            setTempVariant({
                                                                ...tempVariant,
                                                                wholeSalePrice: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm="3">
                                                <FormGroup>
                                                    <Input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Precio Venta"
                                                        onChange={(event) => {
                                                            setTempVariant({
                                                                ...tempVariant,
                                                                retailPrice: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm="3">
                                                <Button
                                                    onClick={_addProductVariant}>
                                                    <i className="mdi mdi-plus"></i>
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row>
                                            {variants[0] && (
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Variante</th>
                                                            <th>Código Vendora</th>
                                                            <th>SKU</th>
                                                            {variants[0].firstOption.label && (
                                                                <th>{variants[0].firstOption.label}</th>
                                                            )}
                                                            {variants[0].secondOption.label && (
                                                                <th>{variants[0].secondOption.label}</th>
                                                            )}
                                                            {variants[0].thirdOption.label && (
                                                                <th>{variants[0].thirdOption.label}</th>
                                                            )}
                                                            <th>Precio Compra</th>
                                                            <th>Precio Vendora</th>
                                                            <th>Precio Venta</th>
                                                            <th>...</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {variants.map((v, i) => {
                                                        return (
                                                            <tr key={i}>
                                                                <td>{v.name}</td>
                                                                <td>{v.vendoraCode}</td>
                                                                <td>{v.sku}</td>
                                                                {v.firstOption.value && (
                                                                    <td>{v.firstOption.value}</td>
                                                                )}
                                                                {v.secondOption.value && (
                                                                    <td>{v.secondOption.value}</td>
                                                                )}
                                                                {v.thirdOption.value && (
                                                                    <td>{v.thirdOption.value}</td>
                                                                )}
                                                                <td>{v.buyPrice}</td>
                                                                <td>{v.wholeSalePrice}</td>
                                                                <td>{v.retailPrice}</td>
                                                                <td>
                                                                    <button onClick={() => {
                                                                            _deleteVariant(v.name)
                                                                        }}
                                                                        className="btn btn-small btn-default">
                                                                        <i className="mdi mdi-delete"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                    </tbody>
                                                </table>
                                            )}
                                        </Row>
                                    </React.Fragment>
                                )}
                            </CardBody>
                        </Card> 
                    </Col>
                </Row>
            </Form>
        </React.Fragment>
    )
}

export default FormPage
